// src/components/Layout.jsx

import React from 'react';
import { Box, Toolbar } from '@mui/material';
import Navbar from './Sidebar';

const Layout = ({ children }) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', bgcolor: '#f5f5f5' }}>
      {/* Navigation Bar */}
      <Navbar />
      
      {/* Spacer for fixed navbar */}
      <Toolbar sx={{ minHeight: { xs: 56, sm: 64 } }} /> 
      
      {/* Main Content */}
      <Box 
        component="main"
        sx={{ 
          p: { xs: 1.5, sm: 2, md: 3 },
          flex: 1,
          overflow: 'auto',
        }}
      >
        {children}
      </Box>
    </Box>
  );
};

export default Layout;